export default __webpack_public_path__ + "static/media/268.f08a62f4.gif";